import Toastify from "toastify-js";

class ProductFilesModal {
	constructor() {
		this.activeSearchQuery = "";
		this.hasBeenDowloaded = "";
		this.isRefreshing = false;
		this.skipModal = false;
		this.ajaxThrottle = null;
		this.selectedFileUrl = "";
		this.downloadBtn = $("#downloadFileBtn");
		this.wlm = $("#productFileModal");
		this.gravityFormId = this.wlm.data("formid");

		const self = this;

		$(document).ready(function() {
			self.modal();
			self.setupGravityFormListener();
		});
	}

	setupGravityFormListener() {
		const self = this;

		jQuery(document).on("gform_confirmation_loaded", function(
			event,
			formId
		) {
			if (
				parseInt(formId) === self.gravityFormId &&
				!self.hasBeenDowloaded
			) {
				// Download the file
				if (self.selectedFileUrl) {
					window.open(self.selectedFileUrl, "_blank");
					self.hasBeenDowloaded = true;
				}
				// Close the modal
				self.wlm.modal("hide");

				Toastify({
					text: ajax.lang_str.product.txt_download_text,
					duration: 5000,
					escapeMarkup: false,
					newWindow: true,
					close: true,
					gravity: "top", // `top` or `bottom`
					position: "center", // `left`, `center` or `right`
					stopOnFocus: true, // Prevents dismissing of toast on hover
					style: {
						background: "#007b92"
					}
				}).showToast();

				window.location.reload();
			}
		});
	}

	submitForm() {
		const self = this;

		$(`#gform_${self.gravityFormId}`).submit();
	}

	handleDocumentClick(e) {
		e.preventDefault();

		const $this = $(e.target);

		// Get element type
		if (e.target.type == "select-one") {
			this.selectedFileUrl = $this.find("option:selected").data("url");
			this.skipModal = $this.find("option:selected").data("skip-modal");
		} else {
			this.selectedFileUrl = $this.data("url");
			this.skipModal = $this.data("skip-modal");
		}

		if (!this.selectedFileUrl) {
			return; // Do nothing if no selection
		}

		if (ajax.language.toLowerCase() !== "sv") {
			window.open(this.selectedFileUrl, "_blank");
			return;
		}

		// Set the input field value to the filename before showing the modal
		const inputField = jQuery(`#input_${this.gravityFormId}_3`); // Assuming the field ID is 3, change it if it's different
		inputField.val(this.selectedFileUrl.split("/").pop()); // Extracting and setting the filename

		if (typeof this.skipModal !== "undefined") {
			this.submitForm();
			return;
		}

		this.wlm.modal("show");
	}

	modal() {
		// Find the hidden field with the class "gfield_visibility_hidden"
		const hiddenField = $('.gfield_visibility_hidden input[type="hidden"]');

		// Add the "hidden" attribute to the hidden field
		hiddenField.attr("hidden", true);
		const self = this;

		// Listen for when modal closes
		this.wlm.on("hidden.bs.modal", function(e) {
			$(".adc-status").remove();
		});

		$(document).on("change", ".documents-select", e =>
			self.handleDocumentClick(e)
		);
		$(document).on("change", ".single-document", e =>
			self.handleDocumentClick(e)
		);
		$(document).on("click", ".document-section .document-link", e =>
			self.handleDocumentClick(e)
		);
		$(document).on("click", ".documents .single-document", e =>
			self.handleDocumentClick(e)
		);
	}
}

export default ProductFilesModal;
